import { Admin  } from "./Admin";
import { AdminAdd } from "./AdminAdd";
import { AdminEdit } from "./AdminEdit";

export {Admin , AdminAdd , AdminEdit} ;